import Paginate from "../../layout/Paginate";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import ListingCard from "../Common/ListingCard";
import ReviewButtons from "../Common/ReviewButtons";

const ReviewsReceieved = () => {
  return (
    <div className="col-span-3 mt-[60px]">
      <FilterHeader title={"Receieved Reviews"} dropdown={false} />
      <ReviewButtons />
      <Paginate
        element={(props) => <ListingCard {...props} />}
        data={new Array(134).fill(0)}
        itemsPerPage={8}
        containerClassName="flex flex-col gap-10 py-10"
      />
    </div>
  );
};

export default ReviewsReceieved;
